module.exports = __webpack_public_path__ + "static/img/tech12.7befe39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tech12.png
// module id = 0GEd
// module chunks = 1